import { ROLES } from "./Acl";
import { AnswerItem } from "./AnswerItem";
import { Appointment, AppointmentID } from "./Appointment";
import { Car, CarID } from "./Car";
import { CarCheckID } from "./CarCheck";
import { ChecklistID } from "./Checklist";
import { Customer, CustomerID } from "./Customer";
import { COMMUNICATION_RESULT_STATUSES } from "./CustomerCommunication";
import { DealerLocationID } from "./DealerLocation";
import { Pin, PIN_TYPES } from "./Pin";
import { Question, QuestionID, QuestionOption } from "./Question";
import { Snooze } from "./Snooze";
import { Tag } from "./Tag";
import { Tyre, TYRE_POSITIONS, TyreID, TyreReplacement } from "./Tyre";

export type QuestionResultID = number;

export type QuestionResultImageID = number;

export type QuestionResultVideoID = number;

export enum QUESTION_RESULT_STATUSES {
  NoStatus = -1,
  FirstWithoutNoStatus = 0,
  OK = 0,
  OKWithRemarks = 1,
  Advice = 2,
  Necessary = 3,
  NVT = 4
}

export interface QuestionResult {
  created_on: string;
  updated_on: string;
  id: QuestionResultID; // Claire Question Result ID
  group_name: string;
  group_order: number;
  question_order: number;
  status: QUESTION_RESULT_STATUSES; // Item's status, refer to that enumeration for more details
  title: string; // Question's title
  completed: boolean; // Question's completion
  mechanic_notes: string; // Mechanic note
  mechanic_fixed: boolean; // The mechanic fixed this item
  customer_approved: boolean; // The customer approved to fix this item
  is_signed_by_customer: boolean; // The customer has explicitly seen and signed for this intervention. Whether it's agreed or declined to be fixed, is not handled by this field
  price: number; // Cost for this item
  raw: string; // A compiled field of all the questions answers and is shown as the item remark. This remark can be edited by the receptionist.
  tyre_position: TYRE_POSITIONS; // 0 if TyreID is null
  tyre_profile: number; // 0 if TyreID is null
  truck_axle: number; // Non-zero value for Truck Question Result Element
  solution: string; // Answer if the question template is of type solution
  solution_value: string; // Value selected if the question template if of type solution
  solution_type: string; // Type selected if the question template if of type solution
  solution_unit: string; // Unit selected if the question template if of type solution
  snoozed: boolean; // Wheter the item is snoozed
  pinned: boolean; // Wheter the item is pinned
  is_hidden_in_history: boolean; // is the question result hidden from the history of advised and critical items not fixed
  question_id: QuestionID;
  tyre_id: TyreID | null; // null if not a tyre question
  appointment_id: AppointmentID;
  car_id: CarID;
  car_check_id: CarCheckID;
  dealer_location_id: DealerLocationID;
  checklist_id?: ChecklistID;
  checklist_name?: string;
  time_car_app?: string; // Appointment date in Claire
  wo_nr?: string; // Appointment work order number
  reg_number?: string; // License plate number
  note?: string;
  type?: ROLES;
  tyre?: Tyre; // joined if TyreID is not null
  tyre_replacements?: TyreReplacement[]; // Deprecated: joined if any
  owner_id?: CustomerID;
  driver_id?: CustomerID;
  contractor_id?: CustomerID;
  owner?: Customer;
  driver?: Customer;
  contractor?: Customer;
  car?: Car;
  checklist_tags?: Tag[];
  question_tags?: Tag[]; // Array of Tag objects associated to this question, refer to that model for more details
  images?: QuestionResultImage[];
  videos?: QuestionResultVideo[];
  answers?: AnswerItem[];
  pin_history?: Pin[];
  snooze_history?: Snooze[]; // Each row represent a log line, showing what changed over time
  appointment?: Appointment; // Appointment
  question_options?: QuestionOption[];
  question?: Question;
  communication_result_status?: COMMUNICATION_RESULT_STATUSES;
  pin_type_id?: PIN_TYPES; // Type of the pin
}

export interface QuestionResultImage {
  created_on: string;
  updated_on: string;
  id: QuestionResultImageID;
  url: string;
  active: boolean;
  visible_to_customer: boolean;
  question_result_id: QuestionResultID;
}

export interface QuestionResultVideo {
  created_on: string;
  updated_on: string;
  id: QuestionResultVideoID;
  url: string;
  active: boolean;
  visible_to_customer: boolean;
  question_result_id: QuestionResultID;
}
